export default __webpack_public_path__ + "static/media/activeHome.066b4d34.svg";